import React from 'react'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { defaultProps } from './index'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import { ToolbarItem } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { ToolbarSection } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ToolbarSection'

export const BannerBlockSettings = () => {
  const themeOpts = [
    { label: 'Light', value: 'light' },
    { label: 'Dark Secondary', value: 'secondarydark' },
  ]

  return (
    <>
      <LayoutToolbarSection defaultProps={defaultProps} initOpen />
      <ToolbarSection title="Tema" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          options={themeOpts}
          label="Tema"
          defaultValue={defaultProps['theme']}
        />
      </ToolbarSection>
      <CtaToolbarSection defaultProps={defaultProps} />
    </>
  )
}
